(function () {

// SELECTORS
    const selectors = {
        sidebarSection: '.custom-sidecart-section',
        sidebarContainer: '.custom-sidecart',
        sidebarQty: 'sidecart-qty',
        headerCartButton: '.site-header-cart--button',
        closeSidebarElement: '[data-close-sidebar]',
        orderNoteBlock: '.custom-sidecart-ordernote',
        orderNoteOpen: '.custom-sidecart__ordernote-open',
        orderNoteClose: '[data-close-ordernote]',
        addToSidecart: 'data-add-to-sidecart',
        formError: '.product-form-error',
        removeProduct: 'data-remove-item',
        qtyInput: '[data-quantity-input]'
    };


// GET SCROLLBAR WIDTH
    let scrollbarWidth = window.innerWidth - document.body.offsetWidth;
    window.addEventListener('resize', () => {
        scrollbarWidth = window.innerWidth - document.body.offsetWidth;
    }, true);


// OPEN SIDECART
    const openSidebar = (e) => {
        if (e) {
            e.preventDefault();
        }
        document.querySelector('body').classList.add('sidebar-opened');
        document.querySelector(selectors.sidebarSection).classList.add('is-open');
        document.querySelector('html').style.paddingRight = scrollbarWidth + 'px';
    }


// CLOSE SIDECART
    const closeSidebar = (e) => {
        e.preventDefault();
        document.querySelector('body').classList.remove('sidebar-opened');
        document.querySelector(selectors.sidebarSection).classList.remove('is-open');
        document.querySelector('html').style.paddingRight = 0;
    }


// SHOW ERROR
    const showError = (el, desc) => {
        const errorWrapper = el.closest('div');
        const productFormError = document.querySelector(selectors.formError);
        if (errorWrapper && !productFormError) {
            const formError = document.createElement('p');
            formError.classList.add('product-form-error');
            formError.innerHTML = desc;
            errorWrapper.insertAdjacentElement('afterend', formError);
        } else {
            productFormError.innerHTML = desc;
        }
    }


// SHOW/HIDE PRODUCT OVERLAY
    const productOverlay = (item, status) => {
        if (status) {
            item.classList.add('is-loading');
        } else {
            item.classList.remove('is-loading');
        }
    }


// CHANGE QTY
    const checkQty = (eventType, thisInput) => {{
        if (thisInput.classList.contains('sidecart-item-qty__input')) {
            if (thisInput.value.match(/[^0-9]/g)) {
                thisInput.value = thisInput.value.replace(/[^0-9]/g, '');
            }

            if (thisInput.value > 1 && thisInput.value >= Number(thisInput.getAttribute('data-max-qty'))) {
                thisInput.value = Number(thisInput.getAttribute('data-max-qty'));
                thisInput.previousElementSibling.removeAttribute('disabled');
                thisInput.nextElementSibling.setAttribute('disabled', 'disabled');
            } else if (thisInput.value > 1 && thisInput.value !== Number(thisInput.getAttribute('data-max-qty'))) {
                thisInput.previousElementSibling.removeAttribute('disabled');
                thisInput.nextElementSibling.removeAttribute('disabled');
            } else if (thisInput.value === 1 && Number(thisInput.getAttribute('data-max-qty')) === 1) {
                thisInput.previousElementSibling.setAttribute('disabled', 'disabled');
                thisInput.nextElementSibling.setAttribute('disabled', 'disabled');
            } else {
                thisInput.previousElementSibling.setAttribute('disabled', 'disabled');
                thisInput.nextElementSibling.removeAttribute('disabled');
            }

            if (eventType === 'change') {
                if (thisInput.value < +thisInput.min) {
                    thisInput.value = +thisInput.min;
                }
                setTimeout(() => {
                    updateProduct(thisInput.closest('.sidecart-item'));
                }, 300);
            }
        }
    }}

    document.addEventListener('input', (e) => {checkQty('input', e.target)});
    document.addEventListener('change', (e) => {checkQty('change', e.target)});

    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('sidecart-item-qty__btn')) {
            const thisInput = e.target.closest('.sidecart-item-qty').querySelector(selectors.qtyInput);
            if (e.target.hasAttribute('data-quantity-minus')) {
                thisInput.value = +thisInput.value - +thisInput.step;
            } else if (e.target.hasAttribute('data-quantity-plus')) {
                thisInput.value = +thisInput.value + +thisInput.step;
            }
            thisInput.dispatchEvent(new Event('change', { 'bubbles': true }));
        }
    });


// ADD PRODUCT
    const addProduct = (event) => {
        const thisBtn = event;
        const thisForm = event.closest('[data-product-form]')
        const productFormError = document.querySelector(selectors.formError);
        let config;

        thisBtn.classList.add('is-loading');

        if (productFormError) {
            productFormError.remove();
        }

        if (thisForm) {
            config = {
                method: 'POST',
                headers: {
                    'Accept': `application/javascript`,
                    'X-Requested-With': 'XMLHttpRequest'
                }
            };

            const formData = new FormData(thisForm);
            formData.append('sections', getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            config.body = formData;
        } else if (thisBtn.hasAttribute('data-variant-id')) {
            const productId = thisBtn.getAttribute('data-variant-id');
            const productIncrement = +thisBtn.getAttribute('data-product-increment');
            config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.headers['Content-Type'] = 'application/json';
            config.body = JSON.stringify({
                id: productId,
                quantity: productIncrement,
                sections: getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname,
            });
        }

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status === 422) {
                    const productTitle = thisBtn.closest('.product-details').querySelector('.product-title').innerText;
                    const maxQty = +document.querySelector('.product-form--atc-button').closest('.product-form__action-wrapper').dataset.maxQty;
                    const errorMessage = `You can't add more than ${maxQty} of ${productTitle} to the cart.`;
                    showError(thisBtn, errorMessage);
                    return;
                }
                renderContents(response, true);
                openSidebar();
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                thisBtn.classList.remove('is-loading');
                if (document.querySelector('body').classList.contains('modal-visible')
                    && event.closest('[data-modal-container]')
                    && document.querySelector('.allow-scroll-while-locked .modal-close')) {
                    document.querySelector('.allow-scroll-while-locked .modal-close').click();
                }
            });
    }


// UPDATE PRODUCT
    const updateProduct = (event) => {
        const productLine = event.getAttribute('data-line-item');
        const productQty = event.querySelector(selectors.qtyInput).value;

        const config = fetchConfig('javascript');
        config.body = JSON.stringify({
            line: productLine,
            quantity: productQty,
            sections: getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
        });

        productOverlay(event, true);

        fetch(`${routes.cart_change_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                renderContents(response);
                productOverlay(event);
            })
            .catch((e) => {
                console.error(e);
            });
    }


// REMOVE PRODUCT
    const removeProduct = (event) => {
        const productLine = event.getAttribute('data-line-item');

        productOverlay(event, true);

        const config = fetchConfig('javascript');
        config.body = JSON.stringify({
            line: productLine,
            quantity: 0,
            sections: getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                renderContents(response, true);
            })
            .catch((e) => {
                console.error(e);
            });

    }


// RENDER CONTENTS
    const fetchConfig = (type = 'json') => {
        return {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
        };
    }

    const renderContents = (parsedState, event = false) => {
        getSectionsToRender().forEach((section => {
            section.selector.forEach((selector) => {
                if (selector !== '#sidecart-related') {
                    document.querySelectorAll(selector).forEach((el) => {
                        el.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
                    });
                }
                if (selector === '#sidecart-related' && event === true) {
                    document.querySelector(selector).innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
                }
            })
        }));

        if (parsedState.item_count === 0 && document.querySelector('.custom-sidecart__related-product')) {
            document.querySelector('.custom-sidecart__related-product').remove();
        }

        const sidecartFooter = document.getElementById('sidecart-footer');
        if (parsedState.item_count === 0) {
            sidecartFooter.classList.add('is-empty');
        } else {
            sidecartFooter.classList.remove('is-empty');
        }
    }

    const getSectionsToRender = () => {
        return [
            {
                id: 'custom-sidecart',
                selector: ['#sidecart-products', '#sidecart-free-shipping', '#sidecart-total-value', '#sidecart-title', '#sidecart-related']
            },
            {
                id: 'static-header',
                selector: ['.site-header-cart--button']
            }
        ];
    }

    const getSectionInnerHTML = (html, selector = '.shopify-section') => {
        let doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector(selector)) {
            return '';
        }
        return doc.querySelector(selector).innerHTML;
    }


// INIT SLIDER
    const relatedProductsInit = () => {
        const relatedSlider = new Swiper('.cart-also-like', {
            slidesPerView: 1,
            spaceBetween: 10,
            autoHeight: true,
            navigation: {
                prevEl: ".custom-sidecart__slider-nav-prev",
                nextEl: ".custom-sidecart__slider-nav-next",
            },
        })
    }


// PRODUCT RECOMMENDATIONS
    class ProductRecommendations extends HTMLElement {
        constructor() {
            super();

            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);

                fetch(this.dataset.url)
                    .then(response => response.text())
                    .then(text => {
                        const html = document.createElement('div');
                        html.innerHTML = text;
                        const recommendations = html.querySelector('product-recommendations');

                        if (recommendations && recommendations.innerHTML.trim().length) {
                            this.innerHTML = recommendations.innerHTML;
                        }

                        // init "You May Also Like" slider
                        relatedProductsInit();
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }
            new IntersectionObserver(handleIntersection.bind(this)).observe(this);
        }
    }
    customElements.define('product-recommendations', ProductRecommendations);


// CLICK EVENTS
    window.addEventListener('DOMContentLoaded', () => {

        // open sidecart
        const cartBtns = document.querySelectorAll(selectors.headerCartButton);
        if (cartBtns.length) {
            cartBtns.forEach(cartBtn => cartBtn.addEventListener('click', (e) => {
                openSidebar(e);
            }))
        }

        // close sidecart
        const closeEl = document.querySelectorAll(selectors.closeSidebarElement);
        if (closeEl !== undefined) {
            closeEl.forEach((el) => {
                el.addEventListener('click', (e) => {
                    closeSidebar(e);
                })
            })
        }

        // open/close order note
        const orderNoteBtns = document.querySelectorAll([selectors.orderNoteOpen, selectors.orderNoteClose]);
        if (orderNoteBtns) {
            orderNoteBtns.forEach((el) => {
                el.addEventListener('click', (e) => {
                    document.querySelector(selectors.sidebarContainer).classList.toggle('order-note-opened');
                })
            })
        }

        document.addEventListener('click', (e) => {
            // add product to cart
            if (e.target.hasAttribute(selectors.addToSidecart) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.addToSidecart))) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                addProduct(e.target.hasAttribute(selectors.addToSidecart) ? e.target : e.target.closest('button'));
            }

            // remove product
            if (e.target.hasAttribute(selectors.removeProduct) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.removeProduct))) {
                removeProduct(e.target.closest('.sidecart-item'));
            }
        })
    });

    window.addEventListener("load", function (event) {
       setTimeout(function () {
            if (document.querySelector('.swym-add-to-cart-btn')) {
                document.querySelectorAll('.swym-add-to-cart-btn').forEach(function (element) {
                    element.addEventListener('click', function (e) {
                        setTimeout(function () {
                            fetch('/cart.js')
                                .then(response => response.json())
                                .then(text => {
                                    let dataObj = {};
                                    const config = fetchConfig('javascript');
                                    config.body = JSON.stringify({
                                        id: text.items[0].key,
                                        quantity: text.items[0].quantity,
                                        sections: getSectionsToRender().map((section) => section.id),
                                        sections_url: window.location.pathname,
                                    });

                                    fetch(`${routes.cart_change_url}`, config)
                                        .then((response) => response.json())
                                        .then((response) => {
                                            renderContents(response, true);
                                            openSidebar(e);
                                        })
                                        .catch((e) => {
                                            console.error(e);
                                        });

                                })
                        }, 600)
                    })
                })
            }
       }, 3000)
    })
})();
